import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Slider from '@material-ui/core/Slider';
import { analyticsTrack } from '../../../analyticsUtils';

const valueText = (value, submenuTitle) => {
  if (submenuTitle === 'Hourly Rate') {
    return `$${value}/hr`;
  }
  return `${value} yrs`;
};

class SliderSearchInput extends Component {
  constructor(props) {
    super(props);

    const { defaultValue } = props;
    this.state = {
      currentValue: defaultValue,
    };

    this.reset = this.reset.bind(this);
  }

  componentDidMount() {
    const { registerSliderResetFunction } = this.props;
    registerSliderResetFunction(this.reset);
  }

  reset() {
    const { options } = this.props;
    this.setState({ currentValue: options });
  }

  render() {
    const {
      name, options, handleChange, submenuTitle,
    } = this.props;

    return (
      <Fragment key={submenuTitle}>
        <div className="subcontent-title">{submenuTitle}</div>
        <Slider
          min={options[0]}
          max={options[1]}
          value={this.state.currentValue}
          marks={options.map((o) => ({ value: o, label: valueText(o, submenuTitle) }))}
          onChange={(event, selection) => {
            this.setState({ currentValue: selection });
          }}
          onChangeCommitted={(event, selection) => {
            analyticsTrack(`Set ${submenuTitle}`, { location: 'Search Index' });
            this.setState({ currentValue: selection });
            handleChange(name, submenuTitle, selection);
          }}
          aria-labelledby="range-slider"
          valueLabelDisplay="on"
          classNamePrefix="clora-multiselect"
        />
      </Fragment>
    );
  }
}

SliderSearchInput.propTypes = {
  name: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  registerSliderResetFunction: PropTypes.func.isRequired,
  submenuTitle: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.number).isRequired,
  defaultValue: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default SliderSearchInput;
